var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"disabled":"","label":"Respuesta numérica","outlined":"","dense":"","type":"number"}})
}
var staticRenderFns = []

export { render, staticRenderFns }